import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import moment from 'moment';
import { VERSION } from 'common/constants/sm-constants';


@Component({
  selector: 'app-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {
  @ViewChild('comment', {static: false}) comment :ElementRef;
  version = VERSION;

  ngOnInit(): void {
    setTimeout(() => this.createComment(), 0);
  }

  private createComment() {
    const htmlElement = this.comment.nativeElement as HTMLElement;
    const timeDate = moment(this.version.timestamp);
    htmlElement.outerHTML = `
    <!--
        Timestamp | ${this.version.timestamp}
        Hash      | ${this.version.hash}
        DateTime  | ${timeDate.toLocaleString()}
        -------------------------------------------------------------
        ${timeDate.toDate()}
        [${timeDate.year()}@${this.version.version}]
    -->

    `;
  }
}

